import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { WorkflowFile } from 'app/models/workflow-file';

import { WorkflowWizardService } from 'app/services/workflow-wizard.service';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { FormGroup, FormArray } from '@angular/forms';
import { WorkflowTemplateService } from 'app/services/workflow-template.service';
import { AddEditWorkflowFileComponent } from '../add-edit-workflow-file/add-edit-workflow-file.component';
import { formGroupPatchValueNullFriendly } from 'app/helpers/utils';
@Component({
  selector: 'app-manage-files',
  templateUrl: './manage-files.component.html',
  styleUrls: ['./manage-files.component.scss']
})
export class ManageFilesComponent implements OnInit {
  
  @Input() workflowStepCompletionFormGroup: FormGroup;
  @Input() parentsFiles: WorkflowFile[] = [];
  @Input() enableDuplicateFileOption: boolean = false;

  @ViewChild('addEditWorkflowFile', { static: true }) addEditWorkflowFile: AddEditWorkflowFileComponent;
  tableLimitSelect = [5, 10, 20, 30, 50, 100];
  selectedFilesTableLimit: number = 100;
  
  editFileIndex: number = -1;
  editFileOldName: string = '';

  deleteFileIndex: number = -1;
  fileToDelete: WorkflowFile = null;


  constructor(private workflowWizardService: WorkflowWizardService, private workflowTemplateService: WorkflowTemplateService) {
    
  }

  ngOnInit() {
    this.deleteFileIndex = -1;
    this.fileToDelete = null;

  }
  
  deleteFile() {
    this.workflowWizardService.removeFileFromRules(this.fileToDelete, this.workflowStepCompletionFormGroup);

    let filesFormArray: FormArray = (this.workflowStepCompletionFormGroup.controls['files'] as FormArray);
    filesFormArray.removeAt(this.deleteFileIndex);
  }

  editFile(file: WorkflowFile, index: number) {
    this.editFileOldName = file.name;
    this.editFileIndex = index;
    
    let frmGroup: FormGroup = this.workflowTemplateService.getWorkflowFileFormGroup(file, this.workflowStepCompletionFormGroup);
    formGroupPatchValueNullFriendly(frmGroup, file);
    this.addEditWorkflowFile.show(frmGroup);
  }
  innerWidth() {
    return window.innerWidth;
  }

  addNewFile() {
    this.editFileIndex = -1;
    let frmGroup: FormGroup = this.workflowTemplateService.getWorkflowFileFormGroup({} as WorkflowFile, this.workflowStepCompletionFormGroup);
    this.addEditWorkflowFile.show(frmGroup);
  }

  onAddEditFinished(frm: FormGroup) {
    let filesFormArray: FormArray = (this.workflowStepCompletionFormGroup.controls['files'] as FormArray);

    if (this.editFileIndex != -1) {
      formGroupPatchValueNullFriendly(filesFormArray.at(this.editFileIndex) as FormGroup, frm.value);
      let newFileName: string = frm.controls['name'].value;
      if (this.editFileOldName != newFileName) {
        this.workflowWizardService.renameFileInRules(this.editFileOldName, newFileName, this.workflowStepCompletionFormGroup);
      }
      this.editFileIndex = -1;
    } else {
      filesFormArray.push(frm);
      frm.setParent(filesFormArray);
    }
  }
}
